export const iconFontAwesomeEnergyBatteryFull = (
	<i className="fa-solid fa-battery-full"></i>
);
